import { useEffect, useRef } from "react";

import { useAppSelector } from "hooks/redux_hooks";
import { classroomSelectors, localSelectors } from "store";

function VisibilityObserver() {
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const currentUserIsVisible = useAppSelector(classroomSelectors.selectCurrentUserIsVisible());
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    window.flightLogger.log(
      `[VisibilityObserver] visibility changed - reloading User ${currentUserId}`,
    );
    location.reload();
  }, [currentUserId, currentUserIsVisible]);

  return null;
}

export { VisibilityObserver };
